import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { PreviewValidateContent } from './components/PreviewValidateContent';

export default function PlanCuidadoPreview() {

    return (
        <MainContent component={<PreviewValidateContent/>} titulo='Resumen de plan' />
    );

};